<app-navbar [title]="'Pojazdy'">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-dynamic-table [elements]="companies" [tableRows]="tableRows" [module]="'company'"></app-dynamic-table>
